var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-layout",
    { staticStyle: { "flex-direction": "column" } },
    [
      _c("AdminHeader"),
      _c(
        "a-layout",
        { style: { minHeight: "100vh" } },
        [
          _c("AdminSider"),
          _c(
            "a-layout-content",
            {
              staticClass: "mc-content-box",
              style: {
                paddingLeft: _vm.getScrollTop
                  ? _vm.getCollapsed
                    ? "80px"
                    : "230px"
                  : "0"
              }
            },
            [
              _c(
                "a-affix",
                { attrs: { offsetTop: 0 } },
                [_vm.multiTab ? _c("MutiTab") : _vm._e()],
                1
              ),
              _c("AdminPage")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }